<template>
<e-chart ref="chart" @initialized="this.onChartInitialized" />
</template>

<script>
import EChart from '../Charts/ECharts'
export default {
  name: 'PolarScatterChart',
  components: {EChart},
  props: {
    factor: {
      required: true,
      type: Object
    },
    data: {
      required: true,
      type: Object
    },
    unitProp: {
      required: true,
      type: String
    }
  },
  methods: {
    render (isReal) {
      let {factor, unitProp, data: {data}} = this
      let factorId = factor.id
      let values = data.map(data => {
        let value = data[factorId].value
        return Number.isFinite(value) ? data[factorId].value : null
      })
      let max = Math.max(...values)
      let min = Math.min(...values)
      let colors = ['#00ff00', '#ffff00', '#ff9900', '#ff0000', '#674ea7', '#333']
      let valueStep = (max - min) / colors.length
      let chart = this.$refs.chart
      let chartEl = chart.$el
      let xCenter = (chartEl.offsetWidth - 130) / 2
      // colors.reverse()

      let chartOpt = {
        title: {
          text: `${factor.name} ${factor[unitProp]}`,
          left: xCenter,
          textAlign: 'center',
          textStyle: {
            fontSize: 14
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true,
          axisPointer: {
            type: 'cross'
          },
          formatter: function (param) {
            return `<div style="padding: 2px 4px 2px 2px;">
              <h3 style='margin: 0;'>${param[0].axisValue}</h3>
              <p style='margin: 5px 0 0 0;'>
                <span>${param[0].marker}${param[0].seriesName}${param[0].data.isMultipleIntegral ? '(重积分)' : '（原始）'}:</span>
                <span style='margin-left: 8px;'>${param[0].value[2]}</span>
              </p>
            </div>`
          }
        },
        polar: {
          center: [xCenter, chartEl.offsetHeight / 2 + 12],
          radius: (Math.min(chartEl.offsetHeight, chartEl.offsetWidth) - 74) / 2
        },
        angleAxis: {
          type: 'value',
          startAngle: 90
        },
        radiusAxis: {
        },
        series: [{
          coordinateSystem: 'polar',
          name: factor.name,
          type: 'scatter',
          encode: {
            tooltip: [2]
          },
          data: data.map(data => {
            return {
              value: [data['1012'].value, data['1013'].value, data[factorId].value],
              isMultipleIntegral: data['1012'].isMultipleIntegral || data['1013'].isMultipleIntegral || data[factorId].isMultipleIntegral
            }
          })
        }]
      }

      if (data.length > 0) {
        chartOpt.visualMap = {
          type: 'piecewise',
          bottom: 0,
          right: 0,
          min,
          max,
          splitNumber: 6,
          dimension: 2,
          pieces: colors.map((color, index) => {
            let dataMin = Number((min + index * valueStep).toFixed(3))
            let dataMax = Number((min + (index + 1) * valueStep).toFixed(3))
            return {
              min: dataMin,
              max: dataMax,
              label: `${dataMin}-${dataMax}`,
              color
            }
          })
        }
      }

      chart.setOpt(chartOpt)
    },
    onChartInitialized () {
      this.initialized = this
      this.render()
    }
  },
  watch: {
    data () {
      if (this.initialized) {
        this.render()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/PolarScatterChart.vue